import { A2kProgress } from "./A2kProgress.js";
window.customElements.define("a2k-progress", A2kProgress);
